import { getModelTypeIdAndEntityId } from '../config';
import service from './baseService';

export const getTicketPurchaseOrderDetailsService = (id) => {
    return service.get(`/ticket-purchase-orders/${id}`, { params: getModelTypeIdAndEntityId() });
};
